<div class="fetal_medicine header_top">
  <div class="banner">
    <div class="container">
      <h6>Prenatal Screening at NCare IVF</h6>
      <h2 class="visually-hidden">Prenatal Scans at NCare IVF Center</h2>
      <h5>Screening Today, Safeguarding Tomorrow</h5>
      <p>
        At NCare IVF, we prioritize early detection of pregnancy-related risks
        to give your baby the healthiest possible start.
      </p>

      <p>
        Prenatal screening tests help assess the risk of certain genetic,
        chromosomal, and maternal complications early in pregnancy—often before
        any symptoms appear. These tests are safe, evidence-based, and used to
        guide further care and reassurance.
      </p>
      <p>
        We offer a comprehensive suite of screening services at our dedicated
        fetal medicine unit, interpreted by experts in maternal-fetal medicine
        and genetics.
      </p>
    </div>
  </div>
  <div class="fm_sec mt-5">
    <div class="container">
      <h4 class="title_header tac">
        Aneuploidy Screening – Detecting Chromosomal Conditions
      </h4>
      <p class="title_para">
        Aneuploidy refers to the presence of an abnormal number of chromosomes
        in the baby, which can lead to conditions such as Down syndrome (Trisomy
        21), Edwards syndrome (Trisomy 18), or Patau syndrome (Trisomy 13).
      </p>
      <div class="accordion">
        <!-- 1. Amniocentesis -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="iut" checked />
          <label for="iut"
            >Combined First Trimester Screening (FTS) / Enhanced FTS</label
          >
          <div class="content">
            <p>
              <strong>What is it? </strong><br />
              This test combines a blood test (PAPP-A, free beta hCG) with a
              nuchal translucency scan between 11 and 13+6 weeks.
            </p>

            <p>
              <strong>What does it screen for? </strong><br />
              Risk of Trisomy 21, 18, and 13. Enhanced FTS may include
              additional ultrasound markers such as nasal bone, ductus venosus
              flow, and tricuspid regurgitation for improved accuracy.
            </p>

            <p>
              <strong>How accurate is it?</strong><br />
              Up to 90–95% detection rate when combined with ultrasound markers.
            </p>
          </div>
        </div>

        <div class="accordion-item">
          <input type="radio" name="accordion" id="rfa" />
          <label for="rfa">Penta Marker Test</label>
          <div class="content">
            <p>
              <strong>What is the Penta Marker test?</strong><br />
              The Penta Marker Test is an expanded version of First Trimester
              Screening (FTS) that uses five biochemical markers to assess the
              risk for Down syndrome.
            </p>

            <p>
              <strong
                >Is the Penta Marker Test suitable for all pregnancies?</strong
              ><br />
              Yes, it is suitable for all pregnancies, but especially beneficial
              for:
            </p>
            <ul>
              <li>Women with borderline results on standard screening</li>
              <li>Those seeking increased accuracy in early pregnancy</li>
              <li>
                Pregnancies with higher baseline risk, such as advanced maternal
                age or assisted conception
              </li>
            </ul>
          </div>
        </div>

        <!-- 3. Amnioreduction -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="quad" />
          <!-- Quadruple Test Section -->
          <label for="quad">Quadruple Test</label>
          <div class="content">
            <p>
              <strong>What is the Quadruple Test?</strong><br />
              The Quadruple Test is a second-trimester blood screening that
              estimates the risk of chromosomal conditions, particularly Down
              syndrome (Trisomy 21). It is also known as the Quad screen.
            </p>

            <p>
              <strong>When is it performed?</strong><br />
              Ideally between 16 and 21 weeks of pregnancy for best accuracy.
            </p>

            <p><strong>Who is it suitable for?</strong><br /></p>
            <ul>
              <li>Women who missed first-trimester screening</li>
              <li>Those presenting for antenatal care after 14 weeks</li>
              <li>Where NIPT is unavailable or unaffordable</li>
            </ul>

            <p>
              <strong>What does it screen for?</strong><br />
              <strong>Primarily:</strong> Down syndrome (Trisomy 21)<br />
              <strong>May also indicate:</strong>
            </p>
            <ul>
              <li>Trisomy 18 (Edwards syndrome)</li>
              <li>
                Certain pregnancy-related risks (e.g., pre-eclampsia, placental
                insufficiency)
              </li>
            </ul>

            <p>
              <strong>Is it diagnostic?</strong><br />
              No. It is a screening test. A high-risk result requires
              confirmation through diagnostic testing such as amniocentesis.
            </p>

            <p>
              <strong>How are results interpreted?</strong><br />
              Risk calculation is based on biomarker levels and maternal factors
              like age, weight, gestational age, and diabetic status. A positive
              screen indicates elevated risk and prompts further evaluation.
            </p>

            <p><strong>What if the result is high risk?</strong><br /></p>
            <ul>
              <li>Referral for genetic counseling</li>
              <li>Detailed ultrasound scan</li>
              <li>Diagnostic procedures like amniocentesis</li>
              <li>Possibly offering NIPT as a next step</li>
            </ul>

            <p>
              <strong>Is it needed if I’ve already done NIPT?</strong><br />
              No. If NIPT has already been performed, the Quadruple Test is not
              required for chromosomal screening.
            </p>

            <p>
              <strong>Is the Quadruple Test accurate?</strong><br />
              It detects up to 80% of Down syndrome cases when performed during
              the optimal gestational window (16–20 weeks). However, it remains
              a screening—not a diagnostic—test.
            </p>
          </div>
        </div>

        <!-- 4. Cordocentesis -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="nipt" />
          <!-- Non-Invasive Prenatal Testing (NIPT) Section -->
          <label for="nipt">Non-Invasive Prenatal Testing (NIPT)</label>
          <div class="content">
            <p>
              <strong>What is NIPT?</strong><br />
              NIPT is a highly sensitive blood test that analyzes cell-free
              fetal DNA in the mother’s blood to assess for certain chromosomal
              abnormalities.
            </p>

            <p><strong>Which conditions can NIPT screen for?</strong><br /></p>
            <ul>
              <li>Trisomy 21 (Down syndrome)</li>
              <li>Trisomy 18 (Edwards syndrome)</li>
              <li>Trisomy 13 (Patau syndrome)</li>
              <li>
                Optional: Sex chromosome aneuploidies and selected microdeletion
                syndromes
              </li>
            </ul>

            <p>
              <strong>When can it be done?</strong><br />
              From 10 weeks of pregnancy onward.
            </p>

            <p><strong>Who should consider NIPT?</strong><br /></p>
            <ul>
              <li>Women above 35 years of age</li>
              <li>Those with abnormal serum screening results</li>
              <li>Pregnancies with a family history of Down syndrome</li>
            </ul>

            <p>
              <strong>How accurate is it?</strong><br />
              NIPT offers over 99% sensitivity for Down syndrome with a low
              false-positive rate.
            </p>

            <p>
              <strong>Is it diagnostic?</strong><br />
              No. It is a screening test. High-risk results should be confirmed
              through diagnostic procedures like amniocentesis or chorionic
              villus sampling (CVS).
            </p>

            <p>
              <strong>How is it performed?</strong><br />
              A simple maternal blood sample is taken. It is safe and
              non-invasive.
            </p>

            <p>
              <strong>How soon are results available?</strong><br />
              Results are typically available within 7–10 working days,
              depending on the test panel.
            </p>

            <p>
              <strong>Can it be done in twin or IVF pregnancies?</strong><br />
              Yes. While slightly less sensitive in twin pregnancies, NIPT is
              valid and commonly used in twin, IVF, and donor egg pregnancies.
            </p>
          </div>
        </div>

        <!-- 5. Multifetal Reduction -->
        <div class="accordion-item">
          <input type="radio" name="accordion" id="fetal_shunt" />
          <label for="fetal_shunt">Pre-Eclampsia Screening</label>
          <div class="content">
            <p>
              <strong>What is Pre-Eclampsia?</strong><br />
              Pre-eclampsia is a serious complication marked by high blood
              pressure, typically after 20 weeks of pregnancy, which can have
              detrimental effects on both the mother and baby.
            </p>

            <p>
              <strong>When is it screened for?</strong><br />
              Screening typically occurs between 11 and 13+6 weeks of pregnancy,
              using:
            </p>
            <ul>
              <li>Uterine artery Doppler</li>
              <li>Mean arterial pressure</li>
              <li>PAPP-A and PLGF blood markers</li>
              <li>Maternal clinical history</li>
            </ul>

            <p>
              <strong>Why is this important?</strong><br />
              Starting low-dose aspirin before 16 weeks in high-risk women can
              prevent or reduce the severity of pre-eclampsia by up to 60%.
            </p>

            <p>
              <strong>Who is at risk?</strong><br />
              Women at higher risk include those who:
            </p>
            <ul>
              <li>Are first-time mothers</li>
              <li>Have a history of pre-eclampsia</li>
              <li>Are undergoing IVF pregnancies</li>
              <li>Are carrying multiple gestations</li>
              <li>Have hypertension, diabetes, or autoimmune disease</li>
            </ul>

            <p>
              <strong>How is the risk for pre-eclampsia calculated?</strong
              ><br />
              Risk is calculated using a combination of maternal factors, mean
              arterial pressure, uterine artery Doppler measurements, and
              biochemical markers (PlGF and PLGF). These factors are analyzed
              using FMF-approved software to estimate the likelihood of
              developing early- or late-onset pre-eclampsia.
            </p>

            <p>
              <strong>What happens if I’m found to be at high risk?</strong
              ><br />
              If your risk is high, your doctor will recommend starting low-dose
              aspirin (150 mg daily) before 16 weeks, continuing until 36 weeks.
              You will also be monitored more closely with regular scans to
              assess fetal growth and placental health.
            </p>

            <p>
              <strong
                >Is pre-eclampsia screening necessary for low-risk
                women?</strong
              ><br />
              Yes. Even women with no obvious risk factors may develop
              pre-eclampsia. Early screening ensures timely prevention in those
              who may be unknowingly at risk.
            </p>
          </div>
        </div>
        <div class="accordion-item">
          <input type="radio" name="accordion" id="preterm_labour" />
          <!-- Preterm Labour Section -->
          <label for="preterm_labour">Screening for Preterm Labour</label>
          <div class="content">
            <p>
              <strong>What is Preterm Labour?</strong><br />
              Preterm labour is defined as labour occurring before 37 weeks of
              pregnancy, which increases the risk of complications such as
              respiratory distress and developmental delays in the baby.
            </p>

            <p><strong>How is it screened?</strong><br /></p>
            Screening typically involves:
            <ul>
              <li>
                Transvaginal cervical length measurement between 20–24 weeks
              </li>
              <li>Review of maternal history</li>
              <li>Fetal fibronectin test in select cases</li>
            </ul>

            <p><strong>What if I’m high-risk?</strong><br /></p>
            If you are considered high-risk, management options may include:
            <ul>
              <li>Vaginal progesterone</li>
              <li>Cervical cerclage</li>
              <li>Closer monitoring</li>
            </ul>

            <p>
              <strong>Why Choose NCare IVF for Prenatal Screening?</strong
              ><br />
            </p>
            <ul>
              <li>Internationally guided protocols</li>
              <li>Advanced ultrasound and genetic technologies</li>
              <li>Experienced maternal-fetal specialists</li>
              <li>
                Personalized counseling and support throughout your journey
              </li>
            </ul>

            <p>
              Our goal is to provide every expecting parent with peace of mind
              and proactive care through world-class prenatal screening.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="container">

        <div class="ncare-highlight">
            <h2>Expert Fetal Care You Can Trust</h2>
            <p>
                At NCare IVF Kannur, Kerala, our fetal therapy services are led by experienced maternal-fetal medicine
                specialists. Every procedure is personalized to the mother and baby’s specific needs, supported by
                real-time imaging, state-of-the-art technology, and compassionate care.

            </p>
            <p>

                If you have been advised fetal therapy or suspect complications during your pregnancy, our team is
                here to walk with you — every step of the way.
            </p>
        </div>
    </div> -->
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <h5>Not Sure Which Screening Test You Need? Let Us Help.</h5>
        <p>
          Our team will guide you on the right tests based on your stage of
          pregnancy, risk factors, and medical history—so you can move forward
          with clarity and confidence.
        </p>
        <button (click)="contactus()">Book an Appointment</button>
      </div>
    </div>
  </section>
  <section class="comprehensive_solutions_recurrent_implantation_failure mt-5">
    <div class="container">
      <h2 class="title_header tac">
        Why Choose NCare IVF for Prenatal Screening?
      </h2>
      <p class="title_para">
        Our goal is to provide every expecting parent with peace of mind and
        proactive care through world- class prenatal screening.
      </p>

      <div class="card-grid">
        <div class="card">
          <img
            loading="lazy"
            src="../../../../assets/images/fetal_medicine/ivfps_1.webp"
            alt="Icon"
          />
          <strong>Internationally guided protocols</strong>
        </div>
        <div class="card">
          <img
            loading="lazy"
            src="../../../../assets/images/fetal_medicine/ivfps_2.webp"
            alt=" Icon"
          />
          <strong>Advanced ultrasound and genetic technologies</strong>
        </div>
        <div class="card">
          <img
            loading="lazy"
            src="../../../../assets/images/fetal_medicine/ivfps_3.webp"
            alt="Icon"
          />
          <strong>Experienced maternal-fetal specialists</strong>
        </div>
        <div class="card">
          <img
            loading="lazy"
            src="../../../../assets/images/fetal_medicine/ivfps_4.webp"
            alt="Icon"
          />
          <strong
            >Personalized counseling and support throughout your journey</strong
          >
        </div>
      </div>
    </div>
  </section>
</div>
